import { getFeatureFlag, subscribeToFeatureFlagsUpdates } from "@braze/web-sdk";
import { abTest } from "@origin-digital/reporting-client";
import { updateTitleOnVisibilityChange } from "./featureFlagUtils";

// NOTE:
// This is a quick and dirty implementation to test out Braze Feature Flags

export const showCPFeatureFlag = () => {
  subscribeToFeatureFlagsUpdates(() => {
    const featureFlag = getFeatureFlag("bundle_title_tag");
    const featureFlagEnabled = featureFlag?.enabled;

    if (featureFlagEnabled) {
      updateTitleOnVisibilityChange();
    }

    abTest("braze", {
      type: "component",
      location: "tal-client",
      experienceId: `PO : Feature flag ${
        featureFlagEnabled ? "active" : "not active"
      } : CP title`,
    });
  });
};
